import React from 'react';
import DesignOptionFilterForm from '../DesignOptionFilterForm';
import enhance from './enhance';

const WheelOptionFilters = ({
  options,
  wheelFormPlaceHolder,
  setActiveFilters,
  activeFilters,
  clearFilter,
}) => {
  return (
    <DesignOptionFilterForm
      options={options}
      placeHolder={wheelFormPlaceHolder}
      setActiveFilters={setActiveFilters}
      filterName="wheelOption"
      activeFilters={activeFilters}
      clearFilter={clearFilter}
    />
  );
};

export default enhance(WheelOptionFilters);
